export default __webpack_public_path__ + "static/media/tongue-ripple-hit.9da5cc9b.mp3";